import React from 'react'
import styles from '../index.module.less'
const data = [
  { id: 1, title: '开幕致辞', time: '8:50-9:00', cont: '■上汽大通灯塔工厂——传统造车模式被突破 ■数字智能决策，提前预知故障 ■创建管控数字化平台，数字化互联打破数据链壁垒 ■自动化技术在汽车机械制造中的应用 ■汽车制造业智慧物流体系构建' },
  { id: 2, title: '洞察力-探灯塔工厂亮在何处', time: '', cont: 'title' },
  { id: 3, title: '赞助商机会', time: '9:20-9:40', cont: '' },
  { id: 4, title: '主题演讲:新能源转型趋势，能源科技创新应该如何发力', time: '9:40-10:00', cont: '■坚持技术先行，重视绿色零碳 ■光伏、储能等新能源技术的加速升级创新 ■ABCDEFG七大智能制造技术，建立极限制造体系架构 ■上下产业链的协调能力，如何提升效率和良率' },
  { id: 5, title: '上午茶歇、展台参观、互动交流', time: '10:00-10:30', cont: '' },
  { id: 6, title: '融合力-深度融合是关键', time: '', cont: 'title' },
  { id: 7, title: '主题演讲:如何加速数实深度融合，重塑制造企业硬核竞争力', time: '10:30-10:50', cont: '■人机共融的智能制造模式将提升制造系统的柔性和敏捷性 ■如何加快生产制造全过程数字化改革 ■充分利用5G、工业互联网、人工智能、数据中心等新型基础设施的机遇 ■智能制造的安全风险和防控思路' },
  { id: 8, title: '赞助商机会', time: '10:50-11:00', cont: '' },
  { id: 9, title: '圆桌讨论:如何看待国内外智能制造和数字化管控分析的发展现状', time: '11:10-12:00', cont: '■数据资源共享、传输、处理存在挑战等，都制约着数实融合发展 ■加大数字工业装备的创新应用 ■推进企业数据的汇集公开和共享流通 ■推进产学研的联合攻关，持续培养精益化人才 ■发挥数据潜能，优化生产流程和组织形式 ■“供-产-销-运-服”将构建数字化智能化制造体系' },
  { id: 10, title: '午餐时间', time: '12:00-13:30', cont: '' },
  { id: 11, title: '影响力-解制造业发展路径', time: '', cont: 'title' },
  { id: 12, title: '主题演讲:斯凯孚的智能工厂之道', time: '13:30-13:50', cont: '■高级分析提高工厂智能化程度 ■降本增效同时赋能行业的可持续发展 ■为中国新能源汽车行业发展注入“加速度”' },
  { id: 13, title: '赞助商机会', time: '13:50-14:00', cont: '' },
  { id: 14, title: '主题演讲:五十五年成就品质，数字化转型指引未来', time: '14:10-14:30', cont: '■关于陕汽 ■陕汽数字化和信息化的推进历程 ■全流程供应链业务的数字化应用实践' },
  { id: 15, title: '赞助商机会', time: '14:30-14:45', cont: '' },
  { id: 16, title: '主题演讲:灯塔上的日月光，打造绿色、智能工厂', time: '14:45-15:05', cont: '■关于日月光半导体 ■先进封装平台——VIPack ■多样的工业4.0技术，为工厂降本增效 ■打破“卡脖子”困境，打造产业供应链协同' },
  { id: 17, title: '赞助商机会', time: '15:05-15:25', cont: '' },
  { id: 18, title: '下午茶歇、展台参观、互动交流', time: '15:25-15:55', cont: '' },
  { id: 19, title: '主题演讲:加快消费品工业数字化升级', time: '15:55-16:55', cont: '' },
  { id: 20, title: '圆桌讨论:中小制造企业数字化转型之路的实践与探索', time: '16:55-17:40', cont: '■头部企业引领，推动上下游供应链协同共进 ■区块链在智能制造领域的应用 ■从平台化建设出发到智能化应用，重运营，精业务 ■建设智能车间，打造智慧工厂 ■如何跨域数字鸿沟，增强行业间、地区间、企业间的创新、协同和共享能力 ■如何破局数字人才缺口，有效实现“人岗精准匹配”' },
  { id: 21, title: '会议闭幕', time: '17:40', cont: '' },
]
export default function Day1() {
  const style = {
    backgroundColor: 'rgb(34,52,176)',
    color: 'white'
  }
  return (
    <div>
      {
        data.map(i => (
          <div className={styles.item} key={i.id} style={i.cont === 'title' ? style : null}>
            <span className={styles.time}>{i.time}</span>
            <div>
              <span className={styles.title}>{i.title}</span>
              {/* <p>{i.cont === 'title' ? '' : i.cont}</p> */}
            </div>
          </div>
        ))
      }
    </div>
  )
}
